import * as React from "react";
const SvgFiRrPlaneArrival = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-plane-arrival_svg__a)">
      <path
        fill="#062147"
        d="M2.293 8.224A6.53 6.53 0 0 0 5.972 13.4l11.822 5.29c.402.191.831.288 1.262.288.346 0 .691-.062 1.026-.187a2.9 2.9 0 0 0 1.666-1.575 3.004 3.004 0 0 0-1.535-3.946l-2.321-1.07-1.514-8.22a3 3 0 0 0-1.8-2.485l-.794-.338a2 2 0 0 0-1.891.174A2 2 0 0 0 10.999 3v6.024L7.833 7.565 6.647 4.53a2.39 2.39 0 0 0-2.405-1.524 2.31 2.31 0 0 0-1.637.831 2.53 2.53 0 0 0-.58 1.893zM13 2.996l.788.336c.336.146.565.462.61.917l1.272 6.927-2.671-1.23zM4.134 5.128a.32.32 0 0 1 .23-.126h.031a.41.41 0 0 1 .39.257l1.333 3.41c.095.241.278.436.513.544l12.77 5.884c.505.221.736.812.516 1.316a.93.93 0 0 1-.531.502.95.95 0 0 1-.752-.042L6.811 11.584a4.51 4.51 0 0 1-2.529-3.573l-.267-2.495a.52.52 0 0 1 .119-.388M24 23a1 1 0 0 1-1 1H1a1 1 0 1 1 0-2h22a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-plane-arrival_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlaneArrival;
